export default (function() {
  var VideosIndex = function() {
    R.utils.bindCMSPostSearchEvents('#video-filter');
  };

  return VideosIndex;
})();
